import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Stack,
  TextField,
  Autocomplete,
  Tooltip,
  Box,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  InputAdornment,
  IconButton,
  Chip,
  CircularProgress,
  Button
} from "@mui/material";
import { loadPackagesFromServer, loadProductsFromServer } from "../../core/serviceClient";
import { getBranch, getCountry } from "../../data/localSettingsActions";
import Utils from "../../core/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

const AddProduct = ({ onAddItem, fromServiceSetup = false, isFromAddNewPackage = false, isFromPurchaseOrder, isFromProductIntakes, setFetchedProducts, OpenProductSelection, setOverallCategoryList, setNewOverallTypeList, setNewTypeList }) => {
  const [allProducts, setAllProducts] = useState([]);
  const [countryInfo, setCountryInfo] = useState({});
  const [searchText, setSearchText] = useState("");
  const [typeList, setTypeList] = useState([]);
  const [overAllTypeList, setOverAllTypeList] = useState([]);
  const [catList, setcatList] = useState([]);
  const [servicecategory, setservicecategory] = useState("");
  const [serviceType, setserviceType] = useState("");
  const [mainProductList, setMainProductList] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [isEnableModalProduct, setIsEnableModalProduct] = useState(false);

  useEffect(() => {
    loadProducts().then(() => setLoadingProducts(false));
  }, []);

  useEffect(() => {
    if (!Utils.IsNullOrEmpty(allProducts) && isEnableModalProduct) {
      setIsEnableModalProduct(false);
      OpenProductSelection();
    }
  }, [isEnableModalProduct, allProducts])

  const loadPackageDetails = async () => {
    let _result = await loadPackagesFromServer();
    var data = _result.data;
    if (!Utils.IsNullOrEmptyArray(data)) {
      data = data.filter(
        (c) =>
          c.active === true
      );
    }
    return data;
  }
  const loadProducts = async () => {
    setCountryInfo(getCountry());
    let result = await loadProductsFromServer();
    var _package = await loadPackageDetails();
    // var _package = "";
    var data = result.data
    var products = [];
    if (!Utils.IsNullOrEmptyArray(data)) {
      if (!Utils.IsNullOrEmptyArray(_package)) {
        data = [...data, ..._package]
      }
      data = data.filter(
        (c) =>
          c.active === true
      );
      let temTypellist = [];
      let temCatllist = [];
      data.forEach((element) => {
        if (
          !Utils.IsNullOrEmpty(element.class) &&
          !temCatllist.includes(element.class)
        ) {
          temCatllist.push(element.class);
        }
        if (element.isMaterial == true || element.service == true || element.collection == "PackageProduct" &&
          !Utils.IsNullOrEmpty(element.fineline) &&
          !temTypellist.includes(element.fineline)
        ) {
          temTypellist.push(element.fineline);
        }
        if (
          !Utils.IsNullOrEmpty(element.department) &&
          !temTypellist.includes(element.department) &&
          !element.service && !element.isMaterial
        ) {
          temTypellist.push(element.department);
        }
      });
      temTypellist = temTypellist.filter((item) => typeof item === "string" && item.trim() !== "");
      temCatllist = temCatllist.filter((item) => typeof item === "string" && item.trim() !== "");
      setTypeList(temTypellist);
      setOverAllTypeList(temTypellist);
      setcatList(temCatllist);
      setOverallCategoryList(temCatllist);
      setNewOverallTypeList(temTypellist);
      setNewTypeList(temTypellist)
      if (fromServiceSetup === true && !isFromAddNewPackage) {
        data = data.filter((c) =>
          c.active === true && c.service == false && c.isMaterial == false);
      }
      if (isFromAddNewPackage) {
        data = data.filter((c) =>
          c.active === true && ((c.service == true && c.isMaterial == false) || (c.service == false && c.isMaterial == false)));
      }
      if (isFromPurchaseOrder || isFromProductIntakes) {
        data = data.filter(c =>
          c.active === true &&
          c.service === false &&
          c.isMaterial === false
        );
      }
    }
    if (!Utils.IsNullOrEmptyArray(data)) {
      setMainProductList(data);
      setFetchedProducts(data);
      data.forEach((item) => {
        var stringItem = JSON.stringify(item);
        products.push(stringItem);
      });
    }
    setAllProducts(products);
  };

  const handleFilter = (value, type) => {
    if (!Utils.IsNullOrEmpty(value) || !Utils.IsNullOrEmpty(type)) {
      var products = [];
      if (value === "" && type === "category" && serviceType === "") {
        mainProductList.forEach((item) => {
          var stringItem = JSON.stringify(item);
          products.push(stringItem);
        });
        setAllProducts(products);
        setTypeList(overAllTypeList);
        return
      }
      if (value === "" && type === "serviceType" && servicecategory === "") {
        mainProductList.forEach((item) => {
          var stringItem = JSON.stringify(item);
          products.push(stringItem);
        });
        setAllProducts(products);
        setTypeList(overAllTypeList);
        return
      }
      if (type === "category" && value !== "" && !serviceType) {
        getFilterTypes(value);
      }
      // class - servicecategory and fineline - serviceType
      let filterdone = mainProductList.filter((item) => {
        if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service && !item.collection === "PackageProduct") {
          return item.class == servicecategory && item.department == value;
        } else if (type === "serviceType" && value !== "" && servicecategory && (item.isMaterial || item.service) || item.collection === "PackageProduct") {
          return item.class == servicecategory && item.fineline == value
        } else if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service) {
          return item.class == servicecategory && item.department == value;
        } else if (type === "serviceType" && value !== "" && servicecategory && (item.isMaterial || item.service)) {
          return item.class == servicecategory && item.fineline == value
        } else if (type === "serviceType" && value !== "" && servicecategory && !item.isMaterial && !item.service) {
          return item.class == servicecategory && item.department == value;
        } else if (type === "category" && value !== "" && serviceType) {
          return item.calss == value && item.department == serviceType
        } else if (type === "category" && value === "" && serviceType) {
          return item.department == serviceType
        } else if (type === "serviceType" && value === "" && servicecategory) {
          return item.class == servicecategory;
        } else if (type === "category" && value !== "" && !serviceType) {
          return item.class == value;
        } else if (type === "serviceType" && value !== "" && !servicecategory && !item.isMaterial && !item.service) {
          return item.department == value;
        } else if (type === "serviceType" && value !== "" && !servicecategory && (item.isMaterial || item.service)) {
          return item.fineline == value;
        }
      });
      if (!Utils.IsNullOrEmptyArray(filterdone)) {
        filterdone.forEach((item) => {
          var stringItem = JSON.stringify(item);
          products.push(stringItem);
        });
      }
      setAllProducts(products);
    }
  }

  const getFilterTypes = (categoryValue) => {
    let newArr = [];
    mainProductList.map((product) => {
      if (product.class === categoryValue && product.department && !product.isMaterial && !product.service) {
        newArr.push(product.department);
      }
      if (product.class === categoryValue && product.fineline && (product.isMaterial || product.service || product.collection === "PackageProduct")) {
        newArr.push(product.fineline);
      }
    })
    const uniqueNewArr = newArr.filter(
      (item, index, self) => index === self.findIndex((obj) => obj.id === item.id)
    );
    setTypeList(uniqueNewArr);
  }

  const filterProducts = (options, state) => {
    if (Utils.IsNullOrEmpty(state.inputValue)) {
      return options;
    }
    var upperCaseSearchText = state.inputValue.trim().toUpperCase();
    var parsedOptions = [];
    options.forEach((item) => {
      var parsedItem = JSON.parse(item);
      parsedOptions.push(parsedItem);
    });
    var newFilteredProducts = parsedOptions.filter(
      (p) =>
        Utils.ConvertToUpperCase(p.code).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.description).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.shortDesc).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.class).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.classDescription).includes(
          upperCaseSearchText
        ) ||
        Utils.ConvertToUpperCase(p.manufacturer).includes(
          upperCaseSearchText
        ) ||
        Utils.ConvertToUpperCase(p.department).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.departmentDescription).includes(
          upperCaseSearchText
        ) ||
        Utils.ConvertToUpperCase(p.fineline).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.finelineDescription).includes(
          upperCaseSearchText
        ) ||
        Utils.ConvertToUpperCase(p.sku).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.upc).includes(upperCaseSearchText) ||
        Utils.ConvertToUpperCase(p.vendor).includes(upperCaseSearchText)
    );
    var newProducts = [];
    if (!Utils.IsNullOrEmptyArray(newFilteredProducts)) {
      newFilteredProducts.forEach((item) => {
        newProducts.push(JSON.stringify(item));
      });
    }
    return newProducts;
  };

  const addItemToCart = (item) => {
    if (!Utils.IsNullOrEmpty(item)) {
      setSearchText("");
      onAddItem(JSON.parse(item));
    }
  };

  const handleModalAddProduct = () => {
    setIsEnableModalProduct(true);
  }

  return (
    <Grid xs={12} style={{ padding: "0" }} className="productsListSec">
      <Grid spacing={1} container direction="row" className="form-sec p-0" fullWidth>
        <Grid item xs={12} md={12} lg={12} style={(isFromPurchaseOrder || isFromProductIntakes) ? {} : { width: "100%" }}>
          <FormControl fullWidth className="font-size-14">
            <Button
              className="btn btn-secondary align-self-stretch"
              variant="contained"
              style={{ height: "54px", position: "relative", paddingRight: loadingProducts ? "40px" : "16px" }}
              disabled={loadingProducts}
              onClick={handleModalAddProduct}

            >
              <AddShoppingCartIcon /> &nbsp;
              Add Items
              {loadingProducts && (
                <CircularProgress
                  size={22}
                  color="inherit"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                />
              )}
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddProduct;
